import { SaveButton, useNotify, useRefresh } from "react-admin";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";

const SaveButtonIntention = ({ setIsEditIntended }) => {
  const { getValues } = useFormContext();
  const notifyError = useNotifyError();
  const { id } = useParams();

  const notify = useNotify();
  const refresh = useRefresh();

  const handleSaveClick = async () => {
    const formDataToSave = getValues();
    const body = {
      intendedFor: formDataToSave.intendedFor,
      fromFacultyNumber: formDataToSave.fromFacultyNumber,
      toFacultyNumber: formDataToSave.toFacultyNumber,
      studentsCapacity: formDataToSave.studentsCapacity,
    };

    try {
      await dataProvider.customRequest(studentRequests.updateSessionExamIntention(id), body, "PUT");
      refresh();
      notify("Данните са запазени успешно!", { type: "success" });
      setIsEditIntended(false);
    } catch (e) {
      notifyError(e);
    }
  };

  return (
    <SaveButton
      label="Запази"
      onClick={handleSaveClick}
      size="small"
    />
  );
};

export default SaveButtonIntention;
